import React from 'react';
import {navigate} from 'gatsby';
import {Event} from '../../GAClickEvent';
import worldMap from '../../../assets/images/zero-to-one/world-map.png';
import '../../../assets/css/zero-to-one.css';

function Header() {
  return (
    <div className="main d-flex ">
      <div className="col-lg-6 d-flex flex-column justify-content-center container">
        <div className="content-slide-top-container">
          <div className="d-flex flex-column mb-3">
            <h2
              className="font-weight-bold font-size-xl"
              style={{maxWidth: '500px', color: '#4E4B66'}}
            >
              Helping startups go from
            </h2>
            <h2 className="font-weight-bold " style={{color: '#1AA5F8'}}>
              Zero to One.
            </h2>
          </div>

          <p className="lead mb-5" style={{maxWidth: '500px'}}>
            We offer <strong style={{color: '#010101', fontWeight: '600'}}>co-located</strong>{' '}
            Tech/Product leadership with a{' '}
            <strong style={{color: '#010101', fontWeight: '600'}}>global team</strong> of expert
            developers & designers, leveraging AI for rapid iterations to achieve{' '}
            <strong style={{color: '#010101', fontWeight: '600'}}>product-market fit</strong>.
          </p>
          <div className="mt-1">
            <button
              type="button"
              className="main_contact_button btn signup-btn btn-success-home"
              style={{fontWeight: 900, borderRadius: '8px', textTransform: 'unset'}}
              onClick={() => {
                navigate('/contact');
                Event('Contact Us', 'Contact Us button is clicked', window.location.pathname);
              }}
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>

      <div className="col-lg-6 d-none d-lg-block py-5">
        <div
          style={{height: '100%', backgroundImage: `url(${worldMap})`, backgroundSize: 'cover'}}
        />
      </div>
    </div>
  );
}

export default Header;
